import Select from "react-select";

export default function MultiSelect({
  label,
  helperText,
  options,
  value,
  onChange,
  placeholder,
  isMulti = true,
  isDisabled = false,
}) {
  const selectedOptions = isMulti
    ? options.filter((option) => value.includes(option.value))
    : (options.find((option) => option.value === value) ?? null);

  return (
    <label className="block space-y-2">
      {(label || helperText) && (
        <div className="flex items-center justify-between gap-3">
          {label && (
            <span className="text-[13px] font-medium text-(--text-secondary)">
              {label}
            </span>
          )}
          {helperText && (
            <span className="text-xs text-(--text-muted)">{helperText}</span>
          )}
        </div>
      )}
      <Select
        isMulti={isMulti}
        isSearchable
        unstyled
        isDisabled={isDisabled}
        closeMenuOnSelect={!isMulti}
        hideSelectedOptions={false}
        backspaceRemovesValue={false}
        tabSelectsValue={false}
        options={options}
        value={selectedOptions}
        placeholder={placeholder ?? "Search and select..."}
        noOptionsMessage={() => "No matching options"}
        menuPlacement="auto"
        menuPortalTarget={
          typeof document !== "undefined" ? document.body : null
        }
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: 1600,
          }),
        }}
        onChange={(next) => {
          if (isMulti) {
            onChange(next.map((option) => option.value));
          } else {
            onChange(next ? next.value : null);
          }
        }}
        classNames={{
          control: (state) =>
            `min-h-10 rounded-(--radius-md) border bg-(--surface-1) px-3 text-sm text-(--text-primary) transition ${
              state.isFocused
                ? "border-(--brand-primary)"
                : "border-(--border-strong) hover:border-(--brand-primary)/50"
            } ${state.isDisabled ? "opacity-60" : ""}`,
          valueContainer: () => "gap-1.5 py-1.5",
          placeholder: () => "text-sm text-(--text-muted)",
          input: () => "m-0 p-0 text-sm text-(--text-primary)",
          menu: () =>
            "mt-2 overflow-hidden rounded-(--radius-md) border border-(--border-subtle) bg-(--surface-1) shadow-[var(--shadow-popover)]",
          menuList: () => "max-h-[248px] p-1.5",
          option: (state) =>
            `cursor-pointer rounded-(--radius-sm) px-3 py-2 text-sm transition ${
              state.isSelected
                ? "bg-(--pastel-violet) text-(--brand-primary)"
                : state.isFocused
                  ? "bg-(--surface-2) text-(--text-primary)"
                  : "text-(--text-secondary)"
            }`,
          multiValue: () =>
            "rounded-(--radius-sm) border border-(--border-subtle) bg-(--surface-2)",
          multiValueLabel: () =>
            "px-2 py-0.5 text-xs font-medium text-(--text-primary)",
          multiValueRemove: () =>
            "flex items-center rounded-r-(--radius-sm) px-1 text-(--text-muted) transition hover:bg-(--surface-muted) hover:text-(--text-primary)",
          indicatorsContainer: () => "gap-1",
          dropdownIndicator: (state) =>
            `px-1 text-(--text-muted) transition ${
              state.isFocused ? "text-(--text-primary)" : ""
            }`,
          clearIndicator: () =>
            "px-1 text-(--text-muted) transition hover:text-(--text-primary)",
          indicatorSeparator: () => "hidden",
          noOptionsMessage: () => "px-3 py-2 text-sm text-(--text-muted)",
        }}
      />
    </label>
  );
}
